// removed by extract-text-webpack-plugin
module.exports = {"defaultSelect":"Select__defaultSelect___3yBtZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Select/Select.scss
// module id = 604
// module chunks = 0